import { Centrale } from '@urbasolar_dev/urbaconnect-types'

import { DashboardData } from '../../domain/dashboard.types'
import { logger } from '../../utils/logger'
import { useFetchApi } from '../../adapter/fetchApi'
import { GRAPH_VIEW } from '../../domain/enums/dashboard.enum'

export const useDashboardApi = () => {
  const fetchApi = useFetchApi()
  const timezone = window.Intl.DateTimeFormat().resolvedOptions().timeZone
  return {
    getDataProduction: async (
      start: number,
      end: number,
      graphView: GRAPH_VIEW,
      selectedPlant: Centrale | null
    ): Promise<DashboardData[]> => {
      const codeCentrale = selectedPlant && selectedPlant.code_centrale
      const url = codeCentrale
        ? `centrales/${codeCentrale}/data/production?start=${start}&end=${end}&view=${graphView}&timezone=${timezone}`
        : `users/current/centrales/data/production?start=${start}&end=${end}&view=${graphView}&timezone=${timezone}`

      const config = {
        method: 'GET',
      }
      try {
        const data = await fetchApi(url, config)

        if (!data || !Array.isArray(data)) {
          throw new Error(
            `DashboardApi.getDataProduction Bad Dashboard data received : ${JSON.stringify(data)}`
          )
        }

        return data.map((elt) => ({
          epoch: new Date(elt.time).valueOf(),
          value: elt.sum,
        }))
      } catch (error: any) {
        logger.error(error.message)
        return []
      }
    },
    getDataExpectedProduction: async (
      start: number,
      end: number,
      selectedPlant: Centrale | null
    ): Promise<DashboardData[]> => {
      const codeCentrale = selectedPlant && selectedPlant.code_centrale
      const url = codeCentrale
        ? `centrales/${codeCentrale}/data/production-attendue?start=${start}&end=${end}`
        : `users/current/centrales/data/production-attendue?start=${start}&end=${end}`

      const config = {
        method: 'GET',
      }
      try {
        const data = await fetchApi(url, config)

        if (!data || !Array.isArray(data)) {
          throw new Error(
            `DashboardApi.getDataExpectedProduction Bad Dashboard expectedData received : ${JSON.stringify(
              data
            )}`
          )
        }

        return data.map((elt) => ({
          epoch: new Date(elt.month).valueOf(),
          value: elt.value ? Math.round(elt.value) : elt.value,
        }))
      } catch (error: any) {
        logger.error(error.message)
        return []
      }
    },
    getSalesRevenue: async (
      start: number,
      end: number,
      selectedPlant: Centrale | null
    ): Promise<number | null> => {
      const codeCentrale = selectedPlant && selectedPlant.code_centrale
      const url = codeCentrale
        ? `centrales/${codeCentrale}/chiffre-d-affaire?start=${start}&end=${end}&timezone=${timezone}`
        : `users/current/centrales/chiffre-d-affaire?start=${start}&end=${end}&timezone=${timezone}`

      const config = {
        method: 'GET',
      }
      try {
        const data = await fetchApi(url, config)

        if (data === null) return null
        if (typeof data !== 'number' || Number.isNaN(data)) {
          throw new Error(`DashboardApi.getSalesRevenue error : ${JSON.stringify(data)}`)
        }

        return Math.round(data)
      } catch (error: any) {
        logger.error(error.message)
        throw error
      }
    },
  }
}
